import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { PORTFOLIO_RISK_GO_TO_RECOMMENDED } from 'utils/testing/testIDs'

import {
  RecommendedRiskBody,
  RecommendedRiskButtonContainer,
  RecommendedRiskContainer,
  RecommendedRiskContentContainer,
  StyledChevronRight,
} from '../../styled-components'

type Props = {
  isRecommendedRisk: boolean
  handleGoToRecommendedPortfolio: () => void
}

const RecommendedRiskContent = (props: Props) => {
  const { StyledRemoteString } = useRemoteStrings()

  return (
    <RecommendedRiskContainer>
      <AcornsIcon
        icon={
          props.isRecommendedRisk
            ? AcornsIcon.Icon.UtilityUp
            : AcornsIcon.Icon.UtilityAlert
        }
        width="24px"
        height="24px"
      />
      {props.isRecommendedRisk ? (
        <RecommendedRiskBody>
          <StyledRemoteString
            stringKey={'portfolio.risk.recommended'}
            modifiers={[{ bold: 600 }]}
          />
        </RecommendedRiskBody>
      ) : (
        <RecommendedRiskContentContainer>
          <RecommendedRiskBody>
            <StyledRemoteString
              stringKey={'portfolio.risk.not_recommended'}
              modifiers={[{ bold: 600 }]}
            />
          </RecommendedRiskBody>
          <RecommendedRiskButtonContainer
            data-testid={PORTFOLIO_RISK_GO_TO_RECOMMENDED}
            onClick={props.handleGoToRecommendedPortfolio}
          >
            Go to recommended
            <StyledChevronRight
              icon={AcornsIcon.Icon.ChevronRightPortfolio}
              height="12px"
            />
          </RecommendedRiskButtonContainer>
        </RecommendedRiskContentContainer>
      )}
    </RecommendedRiskContainer>
  )
}

export default RecommendedRiskContent
